import React from "react";

import styles from "./SearchBar.module.css";

const SearchBar = ( { onSearch, value, placeholder} ) =>
{

    return (
        <input className={styles.root} 
                type="text" 
                placeholder={placeholder}
                onChange={ (e) => onSearch(e.target.value) }
                value={value}
        ></input>
    )
}

SearchBar.defaultProps = {};

export default SearchBar;